export default {
  id: 60,
  title: 'Target #60 - Evil Triangles',
  url: 'https://cssbattle.dev/play/60',
  colors: ['#191919', '#4F77FF'],
  solution:
    '<a a><a b><a c><style>body,a{background:#191919}a{position:fixed}a[a]{top:75;left:100;width:200;height:100;background:#4F77FF}a[b],a[c]{top:100;background:#191919;width:50;height:50}a[b]{left:100;transform:skewY(45deg);box-shadow:0 50px #4F77FF,100px -100px #191919,100px -50px #4F77FF}a[c]{left:150;transform:skewY(-45deg);box-shadow:0 50px #4F77FF,100px 100px #191919,100px 150px #4F77FF}</style>',
}
